import { cn } from "@/lib/utils"

function Textarea({ className, ref, ...props }: React.ComponentProps<"textarea">) {
  return (
    <textarea
      className={cn(
        "flex min-h-[60px] w-full rounded-md border border-input bg-transparent px-3 py-2 text-base shadow-none placeholder:text-muted-foreground outline-none focus:outline-none focus:border-brand-yellow focus:ring-0 focus-visible:outline-none focus-visible:border-brand-yellow focus-visible:ring-0 disabled:cursor-not-allowed disabled:opacity-50 md:text-sm",
        className
      )}
      ref={ref}
      {...props}
    />
  )
}

export { Textarea }
